module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu drop-edit",
    attrs: {
      "aria-labelledby": "dropdown"
    }
  }, [_c('div', {
    staticClass: "link-user"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "link-user-content"
  }, [_c('span', {
    staticClass: "link-user-content-name"
  }, [_vm._v(_vm._s(_vm.$store.state.user.attributes.profile.attributes.name) + " " + _vm._s(_vm.$store.state.user.attributes.profile.attributes.surnames))]), _vm._v(" "), (_vm.$store.state.user.type === 'Admin') ? _c('span', {
    staticClass: "link-user-content-role",
    on: {
      "click": function($event) {
        return _vm.perfil()
      }
    }
  }, [_vm._v("Administrador general")]) : (_vm.$store.state.user.type === 'Operator' && _vm.$store.state.user.attributes.operator_type === 1) ? _c('span', {
    staticClass: "link-user-content-role",
    on: {
      "click": function($event) {
        return _vm.perfil()
      }
    }
  }, [_vm._v("Operador de envío")]) : (_vm.$store.state.user.type === 'Operator' && _vm.$store.state.user.attributes.operator_type === 2) ? _c('span', {
    staticClass: "link-user-content-role",
    on: {
      "click": function($event) {
        return _vm.perfil()
      }
    }
  }, [_vm._v("Operador de recepción")]) : (_vm.$store.state.user.type === 'Client') ? _c('span', {
    staticClass: "link-user-content-role",
    on: {
      "click": function($event) {
        return _vm.perfil()
      }
    }
  }, [_vm._v("Cliente")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "link link-drop",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePaswood()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('img', {
    staticClass: "img-nav",
    attrs: {
      "src": "/static/img/changePasswoord.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link link-drop",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout()
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('img', {
    staticClass: "img-nav",
    attrs: {
      "src": "/static/img/logout.svg",
      "alt": ""
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-avatar",
    attrs: {
      "id": "dropdown",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "user-circle"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/user/admin.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-online"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-user-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/user/admin.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-option"
  }, [_c('span', [_vm._v("Cambiar contraseña")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-option"
  }, [_c('span', [_vm._v("Cerrar sesion")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2025dc60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/UserMenu.vue
// module id = 1857
// module chunks = 1